import { render, staticRenderFns } from "./FacetRecipeCard.vue?vue&type=template&id=3e77a2c9&"
import script from "./FacetRecipeCard.vue?vue&type=script&lang=js&"
export * from "./FacetRecipeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports